export default "__VITE_ASSET__CCx1sMBD__"